<template>
  <div class="bg-hero bg-center bg-cover h-screen w-screen relative">
    <div
      class="bg-gray-900 bg-opacity-80 h-full w-full flex flex-col items-center justify-center"
    >
      <countdown />

      <div
        class="absolute bottom-5 flex justify-center items-center gap-1 opacity-75 flex-col text-sm text-tuscany-50"
      >
        <span>More Details</span>
        <svg
          class="fill-current"
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          style="transform:;-ms-filter:"
        >
          <path
            d="M16.939 7.939L12 12.879 7.061 7.939 4.939 10.061 12 17.121 19.061 10.061z"
          ></path>
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
import { defineAsyncComponent } from "vue";

export default {
  components: {
    Countdown: defineAsyncComponent(() => import("@/components/Countdown.vue"))
  }
};
</script>
